import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ClientDetails } from '../shared/models/client/client-details';
import { UserIdentifiers } from '../shared/models/users/user-identifiers';

@Injectable({
  providedIn: 'root',
})
export class ClientDetailsService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/clientdetails/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public SyncClientDetails(userIdentifiers: UserIdentifiers): Observable<ClientDetails> {
    return this.http.post<ClientDetails>(`${this.apiUrl}sync`, userIdentifiers);
  }

  public GetClientDetails(userIdentifiers: UserIdentifiers): Observable<ClientDetails> {
    return this.http.post<ClientDetails>(`${this.apiUrl}`, userIdentifiers);
  }
}
